var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgU(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150.17,
    height: 183.163,
    viewBox: "0 0 150.17 183.163",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a6e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#07a1de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#1a95d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#3a82c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#5b6fb5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#6265c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#6f53e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#7d51d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#a44ea7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#d34b71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#dc5158"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f06022"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "U",
    transform: "translate(-64 -38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13337",
    "data-name": "Path 13337",
    d: "M139.088,221.163A78.711,78.711,0,0,1,110.1,215.7,75.254,75.254,0,0,1,86.28,200.71a70.379,70.379,0,0,1-16.226-22.473,66.812,66.812,0,0,1-6-27.665L64,147.689V38H84.4V147.593l.051,2.876a48.026,48.026,0,0,0,15.75,35.315,58,58,0,0,0,77.784,0,48.049,48.049,0,0,0,15.75-35.315v-.116l.032-2.734V38h20.4V147.741l-.032,2.792a66.756,66.756,0,0,1-6,27.7A70.379,70.379,0,0,1,191.91,200.7a75.028,75.028,0,0,1-23.824,14.991,78.58,78.58,0,0,1-28.984,5.462Z",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgU);
export default __webpack_public_path__ + "static/media/U.5d71cab62e8fd8f801cd9e4819949afd.svg";
export { ForwardRef as ReactComponent };